import store from '../store';

export default function (to, from, next) {

    if (store.state.common.isLogin) {
        next()
    } else {
        next('/login')
    }
}
